var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"text-xs-center"},[_c('img',{attrs:{"src":"/static/logo.png","alt":"Logo"}}),_vm._v(" "),_c('h1',{staticClass:"mt-3"},[_vm._v("PÁGINA NÃO ENCONTRADA")]),_vm._v(" "),_c('v-btn',{staticClass:"mt-3",attrs:{"to":"/","large":"","dark":"","color":"primary"}},[_vm._v("VOLTAR")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8abc62ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFound.vue
// module id = null
// module chunks = 